import { Box } from "@chakra-ui/react";

const RadioCard = (props) => {
    const { isChecked, value, handleChange, children } = props;

    return (
        <Box
            as="label"
            width={{ base: "100%", lg: "17vw" }}
            h={{ base: "80%", lg: "inherit" }}
            cursor="pointer"
            borderWidth="1px"
            borderRadius="md"
            bg={isChecked ? "orange.50" : "white"}
            borderColor={isChecked ? "orange.500" : "gray.200"}
            _hover={{ borderColor: "orange.500" }}
            px={5}
            py={3}
        >
            <input
                type="radio"
                name="gradeLevel"
                value={value}
                checked={!!isChecked}
                onChange={handleChange}
                style={{ position: "absolute", opacity: 0 }}
            />
            {children}
        </Box>
    );
};

export default RadioCard;
